// @ts-ignore
import ReactSlider from "react-slider";
import styles from "./styles.module.scss";

interface RangeSliderProps {
  value: number[];
  onChange: (value: number[]) => void;
  /**
   * Smallest gap the two thumbs may be dragged to. Defaults to 0 so dragging can
   * reach every pair the % boxes accept — a gap here would make a typed range
   * jump the moment the recruiter grabbed a thumb.
   */
  minDistance?: number;
  step?: number;
}

const RangeSlider = ({ value, onChange, minDistance = 0, step = 1 }: RangeSliderProps) => {
  const ReactSliderComponent = ReactSlider as any;

  return (
    <div className={styles.sliderWrapper}>
      <ReactSliderComponent
        className={styles.reactSlider}
        value={value}
        min={0}
        max={100}
        step={step}
        minDistance={minDistance}
        pearling
        ariaLabel={["Minimum score", "Maximum score"]}
        renderThumb={(props) => <div {...props} className={styles.thumb} />}
        renderTrack={(props, state) => (
          <div
            {...props}
            className={`${styles.track} ${state.index === 1 ? styles.trackActive : ""}`}
          />
        )}
        onChange={onChange}
      />
    </div>
  );
};

export { RangeSlider };
